module.exports = __webpack_public_path__ + "img/background1.49561e6f.png";